import React, { useEffect, useState, useRef, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';

import Image1 from './images/WhatsApp Image 2026-06-18 at 00.46.04.jpeg';
import Image2 from './images/WhatsApp Image 2026-06-18 at 00.46.05.jpeg';
import Image3 from './images/WhatsApp Image 2026-06-18 at 00.46.06 (1).jpeg';
import Image4 from './images/WhatsApp Image 2026-06-18 at 00.46.06.jpeg';
import Image5 from './images/WhatsApp Image 2026-06-18 at 00.46.07.jpeg';
import Image6 from './images/WhatsApp Image 2026-06-18 at 00.46.05 (1).jpeg';
import Logo from './images/main-logo.png';

// ==========================================
// 🎨 GLOBAL STYLES
// ==========================================
const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&family=Plus+Jakarta+Sans:wght@300;400;500;600&display=swap');

  :root {
    --navy-900: #0a192f;
    --navy-800: #112240;
    --navy-700: #1a3355;
    --gold-500: #d4af37;
    --gold-400: #e6c55c;
    --gold-100: rgba(212,175,55,0.1);
    --text-main: #334155;
    --text-muted: #64748b;
    --bg-light: #f8fafc;
    --white: #ffffff;
    --ease: cubic-bezier(0.25, 0.46, 0.45, 0.94);
    --ease-out: cubic-bezier(0.0, 0, 0.2, 1);
    --transition: all 0.4s var(--ease);
  }

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  html { scroll-behavior: smooth; }

  body {
    font-family: 'Plus Jakarta Sans', sans-serif;
    color: var(--text-main);
    background: var(--bg-light);
    line-height: 1.7;
    overflow-x: hidden;
    -webkit-font-smoothing: antialiased;
  }

  h1, h2, h3, h4, h5, .serif {
    font-family: 'Playfair Display', serif;
    color: var(--navy-900);
  }

  a { text-decoration: none; color: inherit; }
  ul { list-style: none; }
  img { display: block; }

  /* ── Layout ── */
  .container { max-width: 1200px; margin: 0 auto; padding: 0 5%; }
  .section { padding: 100px 0; overflow: hidden; }
  .grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: center; }
  .grid-3 { display: grid; grid-template-columns: repeat(3, 1fr); gap: 2.5rem; }
  .grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 2rem; }

  /* ── Backgrounds ── */
  .bg-white { background-color: var(--white); }
  .bg-light { background-color: var(--bg-light); }
  .bg-navy { background-color: var(--navy-900); }
  .bg-navy h2, .bg-navy h3, .bg-navy .serif { color: var(--white); }
  .bg-navy p { color: #cbd5e1; }

  /* ── Scroll Progress ── */
  .scroll-progress {
    position: fixed; top: 0; left: 0; height: 3px;
    background: linear-gradient(90deg, var(--gold-500), var(--gold-400));
    z-index: 2000; width: 0%;
    transition: width 0.1s linear;
  }

  /* ── Navigation ── */
  .nav {
    position: fixed; top: 0; left: 0; right: 0;
    z-index: 1000; padding: 1.2rem 0;
    transition: background 0.4s var(--ease), padding 0.4s var(--ease), box-shadow 0.4s var(--ease);
  }
  .nav.scrolled {
    background: rgba(10, 25, 47, 0.97);
    backdrop-filter: blur(12px);
    padding: 0.8rem 0;
    box-shadow: 0 4px 30px rgba(0,0,0,0.3);
    border-bottom: 1px solid rgba(212,175,55,0.15);
  }
  .nav-content { display: flex; justify-content: space-between; align-items: center; }
  .nav-logo {
    color: var(--gold-500); font-family: 'Playfair Display', serif;
    font-size: 1.6rem; font-weight: 700; letter-spacing: 2px;
    transition: opacity 0.3s;
  }
  .nav-logo:hover { opacity: 0.85; }

  .nav-links { display: flex; gap: 2.5rem; align-items: center; }
  .nav-link {
    color: #cbd5e1; font-weight: 500; font-size: 0.82rem;
    text-transform: uppercase; letter-spacing: 1.5px;
    position: relative; padding-bottom: 4px;
    transition: color 0.3s var(--ease);
  }
  .nav-link::after {
    content: ''; position: absolute; bottom: 0; left: 0;
    width: 0; height: 1.5px; background: var(--gold-500);
    transition: width 0.35s var(--ease);
  }
  .nav-link:hover, .nav-link.active { color: var(--gold-500); }
  .nav-link:hover::after, .nav-link.active::after { width: 100%; }

  .hamburger {
    display: none; background: transparent; border: none;
    color: var(--gold-500); cursor: pointer;
    width: 32px; height: 22px; flex-direction: column;
    justify-content: space-between; padding: 0;
  }
  .hamburger span {
    display: block; height: 2px; background: var(--gold-500);
    border-radius: 2px; transform-origin: left;
    transition: transform 0.35s var(--ease), opacity 0.35s var(--ease), width 0.35s var(--ease);
  }
  .hamburger.open span:nth-child(1) { transform: rotate(45deg) translate(1px, -2px); }
  .hamburger.open span:nth-child(2) { opacity: 0; transform: scaleX(0); }
  .hamburger.open span:nth-child(3) { transform: rotate(-45deg) translate(1px, 2px); }

  /* ── Hero ── */
  .hero {
    min-height: 100vh; display: flex; align-items: center;
    position: relative; padding-top: 80px;
    background-color: var(--navy-900); overflow: hidden;
  }
  .hero-bg-wrapper { position: absolute; inset: 0; }
  .hero-bg {
    width: 100%; height: 100%;
    background-size: cover; background-position: center;
    opacity: 0.3;
    animation: zoomBg 22s infinite alternate ease-in-out;
  }
  .hero-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(10,25,47,0.6) 0%, rgba(10,25,47,0.2) 100%);
  }
  @keyframes zoomBg { from { transform: scale(1); } to { transform: scale(1.12); } }

  .hero-content { position: relative; z-index: 10; max-width: 900px; margin: 0 auto; text-align: center; }
  .hero-eyebrow {
    display: inline-block; color: var(--gold-500); font-size: 0.8rem;
    font-weight: 600; letter-spacing: 3px; text-transform: uppercase;
    margin-bottom: 1.5rem; opacity: 0;
    animation: fadeUp 0.8s var(--ease-out) 0.2s forwards;
  }
  .hero-title {
    font-size: 4.8rem; color: var(--white); line-height: 1.08;
    margin-bottom: 1.8rem; opacity: 0;
    animation: fadeUp 0.9s var(--ease-out) 0.45s forwards;
  }
  .hero-title em { color: var(--gold-500); font-style: italic; }
  .hero-subtitle {
    font-size: 1.2rem; color: #94a3b8; margin-bottom: 3rem;
    font-weight: 300; max-width: 650px; margin-inline: auto;
    opacity: 0; animation: fadeUp 0.9s var(--ease-out) 0.7s forwards;
  }
  .hero-cta {
    display: flex; gap: 1rem; justify-content: center; flex-wrap: wrap;
    opacity: 0; animation: fadeUp 0.9s var(--ease-out) 0.9s forwards;
  }
  .hero-scroll {
    position: absolute; bottom: 2.5rem; left: 50%; transform: translateX(-50%);
    z-index: 10; display: flex; flex-direction: column; align-items: center;
    gap: 0.5rem; color: #64748b; font-size: 0.75rem; letter-spacing: 2px;
    text-transform: uppercase; opacity: 0;
    animation: fadeUp 1s var(--ease-out) 1.3s forwards;
  }
  .scroll-line {
    width: 1.5px; height: 40px; background: rgba(255,255,255,0.2);
    position: relative; overflow: hidden;
  }
  .scroll-line::after {
    content: ''; position: absolute; top: -100%; left: 0;
    width: 100%; height: 100%; background: var(--gold-500);
    animation: scrollDrop 1.8s ease-in-out 1.5s infinite;
  }
  @keyframes scrollDrop { 0% { top: -100%; } 100% { top: 200%; } }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(30px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  /* ── Buttons ── */
  .btn {
    display: inline-flex; align-items: center; gap: 0.5rem;
    padding: 0.95rem 2.4rem;
    background: var(--gold-500); color: var(--navy-900);
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600; font-size: 0.9rem;
    letter-spacing: 0.5px; border-radius: 4px;
    transition: var(--transition); border: 2px solid var(--gold-500);
    cursor: pointer; white-space: nowrap;
  }
  .btn:hover {
    background: var(--gold-400); border-color: var(--gold-400);
    transform: translateY(-3px);
    box-shadow: 0 12px 28px rgba(212,175,55,0.3);
  }
  .btn:active { transform: translateY(-1px); }
  .btn-outline {
    background: transparent; color: var(--white);
    border-color: rgba(255,255,255,0.5);
  }
  .btn-outline:hover {
    background: var(--white); color: var(--navy-900);
    border-color: var(--white); box-shadow: 0 12px 28px rgba(255,255,255,0.15);
  }
  .btn-dark {
    background: transparent; color: var(--navy-900);
    border-color: var(--navy-900);
  }
  .btn-dark:hover {
    background: var(--navy-900); color: var(--white);
    box-shadow: 0 12px 28px rgba(10,25,47,0.2);
  }

  /* ── Section Headers ── */
  .section-label {
    display: block; color: var(--gold-500); font-size: 0.75rem;
    font-weight: 600; letter-spacing: 3px; text-transform: uppercase;
    margin-bottom: 1rem; text-align: center;
  }
  .section-title { font-size: 2.8rem; text-align: center; margin-bottom: 1rem; line-height: 1.2; }
  .section-subtitle { text-align: center; color: var(--text-muted); max-width: 680px; margin: 0 auto 4.5rem; font-size: 1.05rem; }

  /* ── Cards ── */
  .card {
    background: var(--white); padding: 2.5rem; border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.04);
    border: 1px solid rgba(0,0,0,0.05);
    transition: transform 0.4s var(--ease), box-shadow 0.4s var(--ease), border-color 0.4s var(--ease);
    height: 100%; display: flex; flex-direction: column;
    position: relative; overflow: hidden;
  }
  .card::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0;
    height: 3px; background: var(--gold-500);
    transform: scaleX(0); transform-origin: left;
    transition: transform 0.4s var(--ease);
  }
  .card:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,0,0,0.08); border-color: transparent; }
  .card:hover::before { transform: scaleX(1); }

  .card-icon {
    width: 52px; height: 52px; background: var(--gold-100);
    border-radius: 12px; display: flex; align-items: center; justify-content: center;
    margin-bottom: 1.5rem; font-size: 1.5rem;
    transition: transform 0.35s var(--ease), background 0.35s var(--ease);
  }
  .card:hover .card-icon { transform: scale(1.1) rotate(5deg); background: rgba(212,175,55,0.2); }

  /* ── Image ── */
  .img-rounded { border-radius: 10px; box-shadow: 0 20px 50px rgba(0,0,0,0.12); width: 100%; object-fit: cover; }

  /* ── Stats ── */
  .stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 0; }
  .stat-item {
    text-align: center; padding: 3rem 2rem;
    border-right: 1px solid rgba(255,255,255,0.08);
  }
  .stat-item:last-child { border-right: none; }
  .stat-number {
    font-family: 'Playfair Display', serif;
    font-size: 3.5rem; font-weight: 700; color: var(--gold-500);
    line-height: 1; margin-bottom: 0.5rem; display: block;
  }
  .stat-label { font-size: 0.85rem; color: #94a3b8; letter-spacing: 1px; text-transform: uppercase; }

  /* ── Member card ── */
  .member-card {
    padding: 1.5rem; background: var(--bg-light);
    border-radius: 8px; border-left: 3px solid var(--gold-500);
    transition: var(--transition);
  }
  .member-card:hover { background: var(--white); box-shadow: 0 8px 20px rgba(0,0,0,0.06); transform: translateX(4px); }
  .member-name { font-family: 'Playfair Display', serif; font-size: 1.05rem; margin-bottom: 0.25rem; }
  .member-role { font-size: 0.82rem; color: var(--gold-500); font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; }
  .member-desc { font-size: 0.82rem; color: var(--text-muted); margin-top: 0.2rem; }

  /* ── Gallery ── */
  .gallery-item {
    border-radius: 10px; overflow: hidden;
    box-shadow: 0 8px 25px rgba(0,0,0,0.1);
    cursor: pointer; position: relative;
  }
  .gallery-item img {
    width: 100%; height: 300px; object-fit: cover;
    transition: transform 0.7s var(--ease);
    display: block;
  }
  .gallery-item:hover img { transform: scale(1.06); }
  .gallery-overlay {
    position: absolute; inset: 0;
    background: rgba(10,25,47,0.5);
    display: flex; align-items: center; justify-content: center;
    opacity: 0; transition: opacity 0.35s var(--ease);
  }
  .gallery-overlay-icon { color: var(--white); font-size: 2rem; }
  .gallery-item:hover .gallery-overlay { opacity: 1; }

  /* ── Lightbox ── */
  .lightbox-backdrop {
    position: fixed; inset: 0; z-index: 9000;
    background: rgba(5, 12, 24, 0.92);
    display: flex; align-items: center; justify-content: center;
    padding: 2rem;
    animation: fadeIn 0.25s var(--ease);
  }
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  .lightbox-img {
    max-width: 90vw; max-height: 85vh;
    border-radius: 8px; object-fit: contain;
    box-shadow: 0 40px 80px rgba(0,0,0,0.5);
    animation: zoomIn 0.3s var(--ease);
  }
  @keyframes zoomIn { from { transform: scale(0.92); opacity: 0; } to { transform: scale(1); opacity: 1; } }
  .lightbox-close {
    position: fixed; top: 1.5rem; right: 1.5rem;
    background: rgba(255,255,255,0.1); border: 1.5px solid rgba(255,255,255,0.2);
    color: var(--white); width: 44px; height: 44px; border-radius: 50%;
    font-size: 1.2rem; cursor: pointer; display: flex; align-items: center; justify-content: center;
    transition: var(--transition);
  }
  .lightbox-close:hover { background: rgba(255,255,255,0.2); }
  .lightbox-nav {
    position: fixed; top: 50%; transform: translateY(-50%);
    background: rgba(255,255,255,0.08); border: 1.5px solid rgba(255,255,255,0.15);
    color: var(--white); width: 48px; height: 48px; border-radius: 50%;
    font-size: 1.3rem; cursor: pointer; display: flex; align-items: center; justify-content: center;
    transition: var(--transition);
  }
  .lightbox-nav:hover { background: rgba(212,175,55,0.25); border-color: var(--gold-500); }
  .lightbox-prev { left: 1.5rem; }
  .lightbox-next { right: 1.5rem; }
  .lightbox-counter {
    position: fixed; bottom: 2rem; left: 50%; transform: translateX(-50%);
    color: rgba(255,255,255,0.5); font-size: 0.85rem; letter-spacing: 2px;
  }

  /* ── Page Transition ── */
  .page-enter { animation: pageIn 0.5s var(--ease-out); }
  @keyframes pageIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }

  /* ── Reveal Animations ── */
  .reveal { opacity: 0; transform: translateY(36px); transition: opacity 0.75s var(--ease-out), transform 0.75s var(--ease-out); }
  .reveal-left { opacity: 0; transform: translateX(-48px); transition: opacity 0.75s var(--ease-out), transform 0.75s var(--ease-out); }
  .reveal-right { opacity: 0; transform: translateX(48px); transition: opacity 0.75s var(--ease-out), transform 0.75s var(--ease-out); }
  .reveal-scale { opacity: 0; transform: scale(0.92); transition: opacity 0.75s var(--ease-out), transform 0.75s var(--ease-out); }
  .revealed { opacity: 1 !important; transform: none !important; }
  .reveal-delay-1 { transition-delay: 0.12s; }
  .reveal-delay-2 { transition-delay: 0.24s; }
  .reveal-delay-3 { transition-delay: 0.36s; }

  /* ── Footer ── */
  .footer { background: var(--navy-900); color: var(--white); padding: 5rem 0 2.5rem; border-top: 1px solid rgba(255,255,255,0.05); }
  .footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr; gap: 4rem; margin-bottom: 3rem; }
  .footer h4 { color: var(--gold-500); margin-bottom: 1.5rem; font-family: 'Plus Jakarta Sans', sans-serif; font-weight: 600; font-size: 0.8rem; letter-spacing: 2px; text-transform: uppercase; }
  .footer p, .footer li { color: #64748b; font-size: 0.92rem; margin-bottom: 0.75rem; line-height: 1.7; }
  .footer a { color: #64748b; transition: color 0.3s; }
  .footer a:hover { color: var(--gold-400); }
  .footer-bottom { border-top: 1px solid rgba(255,255,255,0.06); padding-top: 2rem; display: flex; justify-content: space-between; align-items: center; color: #334155; font-size: 0.82rem; }

  /* ── Quote Block ── */
  .quote-block {
    background: var(--gold-100); border-left: 4px solid var(--gold-500);
    border-radius: 0 8px 8px 0; padding: 1.5rem 2rem;
    margin: 2rem 0;
  }
  .quote-block p { color: var(--text-main); font-style: italic; margin: 0; }

  /* ── Reduced motion ── */
  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after { animation-duration: 0.01ms !important; transition-duration: 0.01ms !important; }
    .hero-bg { animation: none; }
  }

  /* ── Responsive ── */
  @media (max-width: 1024px) {
    .grid-4 { grid-template-columns: repeat(2, 1fr); }
    .stats-grid { grid-template-columns: repeat(2, 1fr); }
    .stat-item:nth-child(2) { border-right: none; }
    .stat-item:nth-child(3), .stat-item:nth-child(4) { border-top: 1px solid rgba(255,255,255,0.08); }
  }

  @media (max-width: 900px) {
    .hero-title { font-size: 3.6rem; }
    .grid-3 { grid-template-columns: repeat(2, 1fr); }
    .footer-grid { grid-template-columns: 1fr 1fr; gap: 2.5rem; }
    .footer-grid > div:first-child { grid-column: 1 / -1; }
  }

  @media (max-width: 768px) {
    .section { padding: 70px 0; }
    .grid-2, .grid-3, .grid-4 { grid-template-columns: 1fr; gap: 2rem; }
    .hero-title { font-size: 2.8rem; }
    .section-title { font-size: 2.1rem; }
    .stats-grid { grid-template-columns: repeat(2, 1fr); }
    .stat-item { border-right: none; border-bottom: 1px solid rgba(255,255,255,0.08); }
    .stat-item:nth-child(odd) { border-right: 1px solid rgba(255,255,255,0.08); }
    .stat-item:last-child, .stat-item:nth-last-child(2):nth-child(odd) { border-bottom: none; }
    .footer-grid { grid-template-columns: 1fr; gap: 2rem; }
    .footer-bottom { flex-direction: column; gap: 0.5rem; text-align: center; }
    .hamburger { display: flex; }
    .nav-links {
      position: absolute; top: 100%; left: 0; right: 0;
      background: rgba(10, 25, 47, 0.98);
      flex-direction: column; padding: 0;
      text-align: center; gap: 0;
      border-bottom: 1px solid rgba(255,255,255,0.08);
      max-height: 0; overflow: hidden;
      transition: max-height 0.45s var(--ease), padding 0.45s var(--ease);
    }
    .nav-links.open { max-height: 400px; padding: 1.5rem 0; }
    .nav-link { padding: 0.85rem 0; display: block; }
    .nav-link::after { display: none; }
    .lightbox-prev { left: 0.75rem; }
    .lightbox-next { right: 0.75rem; }
  }

  @media (max-width: 480px) {
    .hero-title { font-size: 2.2rem; }
    .stat-number { font-size: 2.8rem; }
  }
`;

// ==========================================
// 🛠️ HOOKS
// ==========================================

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
};

// Fixed: stable observer, only runs once per mount
const useReveal = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target); // unobserve after reveal — performance fix
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    const els = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []); // ← empty array: run only on mount
};

// Scroll progress bar
const useScrollProgress = () => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
      const pct = scrollTop / (scrollHeight - clientHeight) * 100;
      setProgress(Math.min(pct, 100));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return progress;
};

// Scrolled nav
const useScrolled = (threshold = 60) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);
  return scrolled;
};

// Animated counter
const useCounter = (target, duration = 2000, shouldStart = false) => {
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!shouldStart) return;
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(eased * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, shouldStart]);
  return value;
};

// ==========================================
// 🧩 COMPONENTS
// ==========================================

const Navigation = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const scrolled = useScrolled();

  useEffect(() => { setIsOpen(false); }, [location.pathname]);
  // Prevent body scroll when menu open
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return (
    <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
      <div className="container nav-content">
        <Link to="/" className="nav-logo">
          <div  style={{height:'4rem', width:'5rem', display: 'inline-block', verticalAlign: 'middle', marginRight: '0.5rem' }}>
            <img style={{ height: '100%', width: '100%', objectFit: 'contain' }} src={Logo} alt="Logo" />
          </div>
          ADWS</Link>

        <button
          className={`hamburger ${isOpen ? 'open' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
          aria-expanded={isOpen}
          style={{ marginRight: '2rem' }}
        >
          <span /><span /><span />
        </button>

        <div className={`nav-links ${isOpen ? 'open' : ''}`}>
          {[
            { path: '/', label: 'Home' },
            { path: '/about', label: 'About Us' },
            { path: '/mission', label: 'Our Mission' },
            { path: '/gallery', label: 'Gallery' }
          ].map(link => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

const ScrollProgress = () => {
  const progress = useScrollProgress();
  return <div className="scroll-progress" style={{ width: `${progress}%` }} />;
};

// Animated stat with intersection observer
const StatItem = ({ number, suffix = '+', label }) => {
  const ref = useRef(null);
  const [started, setStarted] = useState(false);
  const value = useCounter(number, 1800, started);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setStarted(true); obs.disconnect(); } },
      { threshold: 0.5 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div className="stat-item" ref={ref}>
      <span className="stat-number">{started ? value : 0}{suffix}</span>
      <span className="stat-label">{label}</span>
    </div>
  );
};

// Lightbox
const Lightbox = ({ images, index, onClose, onPrev, onNext }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
  }, [onClose, onPrev, onNext]);

  return (
    <div className="lightbox-backdrop" onClick={onClose}>
      <img
        key={index}
        src={images[index]}
        alt={`Gallery image ${index + 1}`}
        className="lightbox-img"
        onClick={(e) => e.stopPropagation()}
      />
      <button className="lightbox-close" onClick={onClose}>✕</button>
      <button className="lightbox-nav lightbox-prev" onClick={(e) => { e.stopPropagation(); onPrev(); }}>‹</button>
      <button className="lightbox-nav lightbox-next" onClick={(e) => { e.stopPropagation(); onNext(); }}>›</button>
      <span className="lightbox-counter">{index + 1} / {images.length}</span>
    </div>
  );
};

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer-grid">
        <div className="reveal-left">
          <h3 className="serif" style={{ fontSize: '1.7rem', marginBottom: '1rem', color: 'var(--white)' }}>
            Alipurduar Doctors'<br />Welfare Society
          </h3>
          <p>Registered under the West Bengal Societies Registration Act, 1961. Committed to social welfare and the advancement of healthcare services in the region.</p>
        </div>
        <div className="reveal-scale reveal-delay-1">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/about">About &amp; Governing Body</Link></li>
            <li><Link to="/mission">Core Objectives</Link></li>
            <li><Link to="/gallery">Event Gallery</Link></li>
          </ul>
        </div>
        <div className="reveal-right reveal-delay-2">
          <h4>Registered Office</h4>
          <p>
            Netaji Road, P.O. – Alipurduar,<br />
            District – Alipurduar,<br />
            West Bengal – 736121, India
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <span>&copy; {new Date().getFullYear()} Alipurduar Doctors' Welfare Society. All Rights Reserved.</span>
        <span>Reg. under W.B. Societies Registration Act, 1961</span>
      </div>
    </div>
  </footer>
);

// ==========================================
// 📄 PAGES
// ==========================================

const Home = () => {
  useReveal();

  return (
    <main className="page-enter">
      {/* HERO */}
      <section className="hero">
        <div className="hero-bg-wrapper">
          <div className="hero-bg" style={{ backgroundImage: `url(${Image3})` }} />
          <div className="hero-overlay" />
        </div>
        <div className="container hero-content">
          <span className="hero-eyebrow">Alipurduar, West Bengal</span>
          <h1 className="hero-title">
            Advancing <em>Healthcare</em><br />Together
          </h1>
          <p className="hero-subtitle">
            Empowering healthcare professionals, supporting community initiatives, and promoting holistic well-being across the Alipurduar region.
          </p>
          <div className="hero-cta">
            <Link to="/mission" className="btn">Our Mission</Link>
            <Link to="/about" className="btn btn-outline">Governing Body</Link>
          </div>
        </div>
        <div className="hero-scroll">
          <div className="scroll-line" />
          <span>Scroll</span>
        </div>
      </section>

      {/* STATS */}
      <section className="bg-navy" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <div className="stats-grid">
          <StatItem number={7} suffix="+" label="Core Objectives" />
          <StatItem number={4} suffix="" label="Governing Members" />
          <StatItem number={12} suffix="+" label="Events Organized" />
          <StatItem number={1961} suffix="" label="Act — Year of Registration" />
        </div>
      </section>

      {/* VISION */}
      <section className="section bg-white">
        <div className="container">
          <div className="grid-2">
            <div className="reveal-left">
              <span className="section-label" style={{ textAlign: 'left' }}>Who We Are</span>
              <h2 className="serif" style={{ fontSize: '2.5rem', marginBottom: '1.5rem', textAlign: 'left', lineHeight: 1.2 }}>
                Building a Progressive<br />Medical Community
              </h2>
              <p style={{ fontSize: '1.05rem', marginBottom: '1.5rem', color: 'var(--text-muted)' }}>
                <strong style={{ color: 'var(--navy-900)' }}>Our Vision:</strong> To build a collaborative and progressive healthcare community that improves medical standards and promotes holistic well-being in society.
              </p>
              <p style={{ fontSize: '1.05rem', marginBottom: '2.5rem', color: 'var(--text-muted)' }}>
                <strong style={{ color: 'var(--navy-900)' }}>Our Mission:</strong> To empower healthcare professionals, support community health initiatives, and contribute meaningfully to national and regional healthcare development.
              </p>
              <Link to="/about" className="btn btn-dark">
                Our Legal Framework &rarr;
              </Link>
            </div>
            <div className="reveal-right">
              <img src={Image6} alt="Doctors in collaboration" className="img-rounded" style={{ height: '440px' }} />
            </div>
          </div>
        </div>
      </section>

      {/* HOW WE SERVE */}
      <section className="section bg-light">
        <div className="container">
          <span className="section-label reveal-scale">What We Do</span>
          <h2 className="section-title reveal-scale">How We Serve</h2>
          <p className="section-subtitle reveal">Dedicated to the advancement of medical science and the welfare of our society.</p>
          <div className="grid-3" style={{ marginBottom: '3.5rem' }}>
            {[
              { icon: '🩺', title: 'Professional Growth', desc: 'Updating medical knowledge and exchanging ideas among healthcare professionals through CME programs and symposiums.' },
              { icon: '❤️', title: 'Community Welfare', desc: 'Organizing blood donation camps, eye screening, and critical disease awareness programs across the region.' },
              { icon: '🎓', title: 'Youth Support', desc: 'Assisting young individuals from economically weaker sections in acquiring scientific medical knowledge.' }
            ].map((obj, idx) => (
              <div key={idx} className={`card reveal-scale reveal-delay-${idx + 1}`}>
                <div className="card-icon">{obj.icon}</div>
                <h3 className="serif" style={{ fontSize: '1.35rem', marginBottom: '0.75rem' }}>{obj.title}</h3>
                <p style={{ color: 'var(--text-muted)', flex: 1, fontSize: '0.95rem' }}>{obj.desc}</p>
              </div>
            ))}
          </div>
          <div className="reveal" style={{ textAlign: 'center' }}>
            <Link to="/mission" className="btn btn-dark">View All Objectives</Link>
          </div>
        </div>
      </section>

      {/* LEADERSHIP */}
      <section className="section bg-white">
        <div className="container">
          <div className="grid-2">
            <div className="reveal-left">
              <img src={Image4} alt="Speaker at event" className="img-rounded" style={{ height: '520px' }} />
            </div>
            <div className="reveal-right">
              <span className="section-label" style={{ textAlign: 'left' }}>Leadership</span>
              <h2 className="serif" style={{ fontSize: '2.5rem', textAlign: 'left', marginBottom: '1rem', lineHeight: 1.2 }}>Our Governing Body</h2>
              <p style={{ fontSize: '1.05rem', color: 'var(--text-muted)', marginBottom: '2.5rem' }}>
                Guided by experienced medical professionals dedicated to maintaining the highest ethical standards in healthcare and community service.
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {[
                  { name: 'Dr. Anna Topno Mogdali', role: 'Chief Patron', desc: 'CMS / APDJ' },
                  { name: 'Dr. Jibesh Kumar Sarkar', role: 'President', desc: 'ACMS' },
                  { name: 'Dr. Sumit Priyadarshi', role: 'Secretary', desc: 'SR. DMO' },
                  { name: 'Dr. M. Aditya Ram', role: 'Treasurer & Scientific Chair', desc: 'ADMO' }
                ].map((member, idx) => (
                  <div key={idx} className="member-card">
                    <div className="member-name">{member.name}</div>
                    <div className="member-role">{member.role}</div>
                    <div className="member-desc">{member.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA / GALLERY TEASER */}
      <section className="section bg-navy" style={{ textAlign: 'center' }}>
        <div className="container">
          <span className="section-label reveal-scale" style={{ color: 'var(--gold-500)' }}>Our Work in Action</span>
          <h2 className="serif reveal-scale" style={{ fontSize: '2.8rem', marginBottom: '1.5rem', color: 'var(--white)' }}>
            Join Our Initiatives
          </h2>
          <p className="reveal reveal-delay-1" style={{ fontSize: '1.1rem', maxWidth: '580px', margin: '0 auto 4rem', color: '#64748b' }}>
            Take a look at our recent symposiums, welfare camps, and community gatherings.
          </p>
          <div className="grid-3 reveal-scale reveal-delay-2" style={{ marginBottom: '3.5rem' }}>
            {[Image1, Image5, Image2].map((src, idx) => (
              <div key={idx} style={{ borderRadius: '10px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
                <img src={src} alt={`Event ${idx + 1}`} style={{ width: '100%', height: '240px', objectFit: 'cover', display: 'block', transition: 'transform 0.6s var(--ease)' }}
                  onMouseOver={e => e.currentTarget.style.transform = 'scale(1.06)'}
                  onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
                />
              </div>
            ))}
          </div>
          <div className="reveal reveal-delay-3">
            <Link to="/gallery" className="btn">Explore Full Gallery</Link>
          </div>
        </div>
      </section>
    </main>
  );
};

const About = () => {
  useReveal();
  const governingBody = [
    { name: 'Dr. Anna Topno Mogdali', role: 'Chief Patron', desc: 'CMS / APDJ' },
    { name: 'Dr. Jibesh Kumar Sarkar', role: 'President', desc: 'ACMS' },
    { name: 'Dr. Sumit Priyadarshi', role: 'Secretary', desc: 'SR. DMO' },
    { name: 'Dr. M. Aditya Ram', role: 'Treasurer & Scientific Chair', desc: 'ADMO' }
  ];

  return (
    <main style={{ paddingTop: '100px', minHeight: '100vh' }} className="page-enter">
      <section className="section bg-white">
        <div className="container">
          <span className="section-label reveal-scale">Who We Are</span>
          <h2 className="section-title reveal-scale">About Us</h2>
          <p className="section-subtitle reveal">A non-profit Society dedicated to the ethical advancement of medicine and community welfare in Alipurduar.</p>

          <div className="grid-2" style={{ marginBottom: '6rem' }}>
            <div className="reveal-left">
              <h3 className="serif" style={{ fontSize: '1.8rem', color: 'var(--navy-900)', marginBottom: '1.25rem' }}>
                Legal &amp; Ethical Framework
              </h3>
              <p style={{ marginBottom: '1rem', color: 'var(--text-muted)' }}>
                The Society functions strictly on a non-profit basis, with prior approval from the competent authority where required. All activities remain within the scope of Section 4(2) of the West Bengal Societies Registration Act, 1961.
              </p>
              <p style={{ color: 'var(--text-muted)' }}>
                Our governance ensures complete transparency — financial records, minutes of meetings, and membership details are maintained meticulously as per statutory requirements.
              </p>
              <div className="quote-block">
                <p>The income and property of the Society shall be used solely for promoting its objectives. No portion shall be distributed among members as profit.</p>
              </div>
            </div>
            <div className="reveal-right">
              <img src={Image1} alt="Society event" className="img-rounded" style={{ height: '420px' }} />
            </div>
          </div>

          <span className="section-label reveal-scale">Leadership</span>
          <h2 className="serif reveal-scale" style={{ fontSize: '2.4rem', textAlign: 'center', marginBottom: '3rem' }}>Complete Governing Body</h2>
          <div className="grid-4">
            {governingBody.map((member, idx) => (
              <div key={idx} className={`card reveal-scale reveal-delay-${idx % 4 + 1}`}>
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'var(--gold-100)', border: '2px solid var(--gold-500)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.25rem', fontSize: '1.1rem', color: 'var(--gold-500)', fontWeight: 700, fontFamily: 'Playfair Display, serif' }}>
                  {member.name.split(' ').filter(w => w !== 'Dr.').map(w => w[0]).join('').slice(0, 2)}
                </div>
                <h3 className="serif" style={{ fontSize: '1.1rem', marginBottom: '0.4rem' }}>{member.name}</h3>
                <p style={{ color: 'var(--gold-500)', fontWeight: 600, marginBottom: '0.4rem', fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{member.role}</p>
                <p style={{ color: 'var(--text-muted)', fontSize: '0.82rem' }}>{member.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

const MissionServices = () => {
  useReveal();
  const objectives = [
    { icon: '🩺', title: 'Professional Development', desc: 'Updating medical knowledge and providing a platform for discussion and collaboration among professionals.' },
    { icon: '🤝', title: 'Collaboration & Networking', desc: 'Fostering cooperation with similar organizations to enhance healthcare standards across the region.' },
    { icon: '🧑‍⚕️', title: 'Healthcare Promotion', desc: 'Engaging in promotive, preventive, and curative programs. Organizing CME programs, symposiums, and quizzes.' },
    { icon: '🇮🇳', title: 'National Health Participation', desc: 'Actively participating in National Health Programs to achieve national goals and improve public health outcomes.' },
    { icon: '🔬', title: 'Scientific Growth', desc: 'Encouraging and supporting members in their scientific and research activities to advance medical knowledge.' },
    { icon: '🎓', title: 'Youth Support', desc: 'Assisting young individuals from economically weaker sections in acquiring scientific medical knowledge.' },
    { icon: '❤️', title: 'Community Welfare', desc: 'Organizing blood donation camps, eye screening camps, and awareness programs on cancer, HIV/AIDS, and more.' }
  ];

  return (
    <main style={{ paddingTop: '100px', minHeight: '100vh', background: 'var(--bg-light)' }} className="page-enter">
      <section className="section">
        <div className="container">
          <span className="section-label reveal-scale">What Drives Us</span>
          <h2 className="section-title reveal-scale">Services &amp; Objectives</h2>
          <p className="section-subtitle reveal">
            Established with a commitment to social welfare and the advancement of healthcare services in the Alipurduar region.
          </p>
          <div className="grid-3">
            {objectives.map((obj, idx) => (
              <div key={idx} className={`card reveal-scale reveal-delay-${idx % 3 + 1}`}>
                <div className="card-icon">{obj.icon}</div>
                <h3 className="serif" style={{ fontSize: '1.3rem', marginBottom: '0.75rem' }}>{obj.title}</h3>
                <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', flex: 1 }}>{obj.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

const Gallery = () => {
  useReveal();
  const images = [Image1, Image2, Image3, Image4, Image5, Image6];
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const openLightbox = useCallback((idx) => setLightboxIndex(idx), []);
  const closeLightbox = useCallback(() => setLightboxIndex(null), []);
  const prevImage = useCallback(() => setLightboxIndex(i => (i - 1 + images.length) % images.length), [images.length]);
  const nextImage = useCallback(() => setLightboxIndex(i => (i + 1) % images.length), [images.length]);

  return (
    <main style={{ paddingTop: '100px', minHeight: '100vh' }} className="page-enter">
      <section className="section bg-white">
        <div className="container">
          <span className="section-label reveal-scale">Memories</span>
          <h2 className="section-title reveal-scale">Event Gallery</h2>
          <p className="section-subtitle reveal">
            Glimpses from our recent symposiums, welfare camps, and community gatherings. Click any image to view full-size.
          </p>
          <div className="grid-3">
            {images.map((src, idx) => (
              <div
                key={idx}
                className={`gallery-item reveal-scale reveal-delay-${idx % 3 + 1}`}
                onClick={() => openLightbox(idx)}
                role="button"
                tabIndex={0}
                aria-label={`Open image ${idx + 1}`}
                onKeyDown={e => e.key === 'Enter' && openLightbox(idx)}
              >
                <img src={src} alt={`Society Event ${idx + 1}`} />
                <div className="gallery-overlay">
                  <span className="gallery-overlay-icon">⊕</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {lightboxIndex !== null && (
        <Lightbox
          images={images}
          index={lightboxIndex}
          onClose={closeLightbox}
          onPrev={prevImage}
          onNext={nextImage}
        />
      )}
    </main>
  );
};

// ==========================================
// 🚀 APP
// ==========================================
export default function App() {
  return (
    <Router>
      <style>{globalStyles}</style>
      <ScrollToTop />
      <ScrollProgress />
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navigation />
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/mission" element={<MissionServices />} />
            <Route path="/gallery" element={<Gallery />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}